import { createContext } from 'react';

var SearchContext = /*#__PURE__*/createContext({
  hideResults: function hideResults() {}
});

export default SearchContext;
